import { createStore } from "redux";

const userDetail = (state, action) => {
  var newState = {};
  if (action.type == "GET_USERDETAIL") {
    newState["userDetail"] = action.detail;
    newState["pageName"] = action.page;
  } else {
    newState["userDetail"] = null;
    newState["userDetail"] = null;
  }
  return newState;
};

const translation = (state, action) => {
  var newState = {};
  if (action.type === "TRANSLATION") {
    newState["data"] = action.data;
  } else {
    newState["data"] = null;
  }
  return newState;
};

const images = (state, action) => {
  if (state) {
    var newState = state;
  } else {
    newState = {};
  }
  if (action.type == "SET_IMG") {
    newState["data"] = action.data;
  }
  return newState;
};
const socialShared = (state, action) => {
  if (state) {
    var newState = state;
  } else {
    newState = {};
  }
  if (action.type == "SET_SHARED") {
    newState["data"] = action.data;
  }
  return newState;
};
const mailSuccess = (state, action) => {
  if (state) {
    var newState = state;
  } else {
    newState = {};
  }
  if (action.type == "SET_SUCCESS") {
    newState["data"] = action.data;
  }
  return newState;
};

const listApi = (state, action) => {
  var newState = {};
  if (action.type === "GET_LIST") {
    newState["data"] = action.data;
  } else {
    newState["data"] = null;
  }
  return newState;
};

const userDetailStore = createStore(userDetail);
const listApiStore = createStore(listApi);
const translationStore = createStore(translation);
const imageStore = createStore(images);
const shareSuccessStore = createStore(socialShared);
const mailSuccessStore = createStore(mailSuccess);

export default userDetailStore;
export { userDetailStore, listApiStore, translationStore, imageStore, shareSuccessStore, mailSuccessStore };
